export const setVariables = (variables) => ({
  type: "SET_VARIABLES",
  payload: variables,
});

export const setWorkflows = (workflows) => ({
  type: "SET_WORKFLOWS",
  payload: workflows,
});
